// LICENSE_CODE ZON
'use strict'; /*jslint ts:true, react: true*/
import React, {Fragment, useState, useContext} from 'react';
import {Link} from 'react-router-dom';
import {Editor} from '../../../shared/editor/editor';
import {Button} from '../../../shared/button';
import {Settings_context} from '../settings_ctx';
import cn from 'classnames';
import styles from './help_tiles.module.less';

interface i_help_tiles_props {
  tiles: {title: string; link: string}[]
}

export const Help_tiles = ({tiles}: i_help_tiles_props)=>{
  const {theme} = useContext(Settings_context);
  return <div className={cn(styles.tiles_container)}>
      {tiles.map(({title, link}, index)=><Link key={index}
        className={cn(styles.tile)} to={link}>
          <p className={`${theme.p3} ${styles.tile_text}`}>{title}</p>
        </Link>)}
    </div>;
};

interface i_help_tiles_editor_props {
  value: i_help_tiles_props;
  on_change: (new_value: i_help_tiles_props)=>void;
}

export const Help_tiles_editor = (props: i_help_tiles_editor_props)=>{
  const {value, on_change} = props;
  const [state, set_state] = useState({tiles: value.tiles || []});
  return <Editor value={state} on_change={on_change}
    editors={[]} on_save={()=>on_change(state)}>
    <Fragment>
      {state.tiles.map((tiles, i)=><div key={i}>
          <Editor
            editors={[
              {key: 'title', label: 'Title', type: 'text'},
              {key: 'link', label: 'Link', type: 'text'},
            ]}
            value={tiles}
            on_change={(b: typeof tiles)=>{
              const new_items = [...state.tiles];
              new_items[i] = b;
              set_state({tiles: new_items});
            }}/>
          <Button caption="Delete item" size="xs"
            on_click={()=>{
              set_state({
                tiles: state.tiles
                  .filter((_, index)=>index!==i)
              });
            }}/>
          <hr/>
        </div>)}
      <Button caption="Add new item" size="xs"
        on_click={()=>set_state(
          {tiles: [...state.tiles, {title: '', link: ''}]}
        )}/>
    </Fragment>
  </Editor>;
};
